import { isSecureUrl } from 'shared/utils/validation';
import isEmail from 'validator/es/lib/isEmail';

type ValidationError =
  | 'emailError'
  | 'positiveIntegerError'
  | 'requiredError'
  | 'urlError';

type ValueWithLength = {
  length: number;
};

type ValueWithSize = {
  size: number;
};

export const validPhonenumber = (
  value?: string | null,
): string | undefined => {
  if (!value) {
    return undefined;
  }

  return value.match(/^\+?[\d\s-\/\(\)]*$/gm)
    ? undefined
    : 'Please only use numbers, spaces, +, (, ), and /';
};

export const required = (value: unknown): ValidationError | undefined =>
  value ? undefined : 'requiredError';

export const requiredArray = (
  value?: ValueWithSize | null,
): ValidationError | undefined =>
  value && value.size >= 1 ? undefined : 'requiredError';

export const email = (value?: string | null): ValidationError | undefined =>
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value ?? '',
  ) || !value
    ? undefined
    : 'emailError';

export const senderAddress = (
  value?: string | null,
): ValidationError | undefined =>
  value && !isEmail(value) ? 'emailError' : undefined;

export const commaSeparatedEmails = (
  value?: string | null,
): ValidationError | undefined => {
  if (!value || !value.trim()) return undefined;
  const parts = value.split(',').filter((part) => part.trim());
  return parts.length && parts.every((part) => isEmail(part.trim()))
    ? undefined
    : 'emailError';
};

export const maxLength =
  (max: number) =>
  (
    value?: ValueWithLength | null,
  ): { message: 'maxLengthError'; value: number } | undefined =>
    value && value.length > max
      ? { message: 'maxLengthError', value: max }
      : undefined;

export const url = (value?: string | null): ValidationError | undefined =>
  !value || isSecureUrl(value) ? undefined : 'urlError';

export const positiveInteger = (
  value?: string | number | null,
): ValidationError | undefined => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = parseInt(String(value), 10);
  return parsed <= 0 ? 'positiveIntegerError' : undefined;
};
